import * as React from 'react';

const Callback = () => {
  return (
    <div>
      <h1>Please wait...</h1>
    </div>
  );
};
export default Callback;
